import { prices } from '../lists/prices_list.js'

export function ProductDisplay() {
    return (
        <>
        {prices.map((item, index) => {
            if (item.type === 'simple') {
                return (
                    <div key={index} className="box simple" style={{backgroundImage: `url(${item.displays})`, display: `${item.disp}`}}>
                        <div className="product_title">{item.product_title}</div>
                        <div className='product_title' style={{width: '100%', position: 'absolute', bottom: '80px'}}>{item.main_description}</div>
                        <div className="product_prices">{item.price}€</div>
                    </div>
                );
            }

            if (item.type === 'complex') {
                return (
                    <div key={index} className="box complex" style={{display: `${item.disp}`}}>
                        <div className="product_title" style={{color: 'black'}}>{item.product_title}</div>
                        <div className='image_box_container'><img className='image_box' src={item.main_img} alt={item.main_alt}/></div>
                        <div className='product_title' style={{color: 'black', marginTop: '30px', marginBottom: '30px'}}>{item.main_description}</div>
                        <div className='double_box_images_container'>
                            <div className='box_wrap mrg_right'>
                                <div className='double_box'><img className='image_box' src={item.small_img_1} alt={item.alt_img_1}/></div>
                                <div className='product_description' style={{color: 'black'}}>{item.secondary_description_1}</div>
                            </div>
                            <div className='box_wrap'>
                                <div className='double_box'><img className='image_box' src={item.small_img_2} alt={item.alt_img_2}/></div>
                                <div className='product_description' style={{color: 'black'}}>{item.secondary_description_2}</div>
                            </div>
                        </div>
                        <div className='product_prices'>{item.price}</div>
                    </div>
                );
            }

            return null;
        })}
        </>
    );
}